// extracted by mini-css-extract-plugin
export default {"title":"KQ34pn2BudtO8_wQACbW","total":"hWkvfyJLDAl6paWrIyA4","valueBox":"TozM4KMYwhq3x4i8zLFy","value":"eOM7__OvBDQ7vIdJ6Uvm"};